import { render, staticRenderFns } from "./UploadFileForm.vue?vue&type=template&id=64081a9d&"
import script from "./UploadFileForm.vue?vue&type=script&lang=js&"
export * from "./UploadFileForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileForm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports